module.exports = __webpack_public_path__ + "static/media/sightnight-5.c181b04e.jpg";